import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import logo from '../../assets/img/56.png';

const RegistroExitosoPage = ({ setCurrentPage, username, tipoRegistro = 'preadmision', returnTo }) => {
    const mensaje = tipoRegistro === 'preadmision'
        ? '¡Tu registro de preadmisión fue realizado con éxito!'
        : '¡Tu registro al curso de extensión fue realizado con éxito!';

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-gray-100 flex justify-center items-center p-4">
            <div className="absolute top-0 left-0 w-full h-2 bg-[#1e3a8a]"></div>

            <div className="bg-white p-8 shadow-xl rounded-2xl w-full max-w-md border border-gray-100">
                {/* Logo */}
                <div className="flex justify-center mb-6">
                    <img
                        src={logo}
                        alt="EBID Logo"
                        className="w-20 h-20 object-contain"
                    />
                </div>

                {/* Ícono de éxito */}
                <div className="flex justify-center mb-4">
                    <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
                        <CheckCircle2 className="w-12 h-12 text-green-600" />
                    </div>
                </div>

                {/* Mensaje de éxito */}
                <h2 className="text-2xl font-bold text-center text-[#1e3a8a] mb-4">
                    {mensaje}
                </h2>

                {/* Información del usuario */}
                <div className="bg-blue-50 border-l-4 border-blue-600 p-4 mb-6">
                    <p className="text-sm text-gray-700 mb-2">
                        Tu registro se ha completado exitosamente.
                    </p>
                    {username && (
                        <div className="mt-3">
                            <p className="text-xs text-gray-600 font-medium">Tu usuario es:</p>
                            <p className="text-lg font-bold text-[#1e3a8a]">{username}</p>
                        </div>
                    )}
                </div>

                <div className="space-y-3 text-sm text-gray-600 mb-6">
                    <p>✓ Tu cuenta ha sido verificada exitosamente</p>
                    <p>✓ Tu información ha sido registrada</p>
                    <p>✓ Ya puedes iniciar sesión con tu usuario</p>
                </div>

                <button
                    onClick={() => returnTo ? setCurrentPage(returnTo) : setCurrentPage('login')}
                    className="w-full bg-[#1e3a8a] text-white py-3 rounded-full hover:bg-[#2c4a9a] transition font-semibold"
                >
                    {returnTo ? 'Volver al Sistema' : 'Ir a Iniciar Sesión'}
                </button>
            </div>
        </div>
    );
};

export default RegistroExitosoPage;
